import React from 'react';
import { MapPinned, Anchor, Shield, TrendingUp } from 'lucide-react';

const Feature = ({ icon: Icon, label }) => (
  <div className="flex items-center space-x-2 text-sm">
    <Icon className="w-4 h-4 text-[#143160]" />
    <span className="text-gray-700">{label}</span>
  </div>
);

export const RelocationFeatureStrip = ({ area }) => (
  <div className="px-6 py-4 bg-gradient-to-b from-blue-50 to-white border-b">
    <div className="grid grid-cols-2 gap-3">
      <Feature icon={MapPinned} label="Neighborhood Guides" />
      <Feature icon={Anchor} label="Beach Communities" />
      <Feature icon={Shield} label={area === 'outer_banks' ? 'Coast Guard Base Info' : 'Military Base Info'} />
      <Feature icon={TrendingUp} label="Market Insights" />
    </div>
  </div>
);

export const RelocationSuccess = () => (
  <div className="text-center py-6">
    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <h4 className="text-xl font-bold text-gray-900 mb-2">Your Guide is on the Way!</h4>
    <p className="text-gray-600">Check your email for your 2026 Coastal Relocation Guide.</p>
  </div>
);
